import { Box, type SxProps, type Theme } from '@mui/material';

interface LiveDotProps {
  size?: number;
  sx?: SxProps<Theme>;
}

/** Small pulsing emerald dot indicating a live/active/synchronized state
 * (workspace sync badge, "AI Mesh Active", chat "Connected" indicator). */
export function LiveDot({ size = 8, sx }: LiveDotProps) {
  return (
    <Box
      component="span"
      className="pulse-dot"
      sx={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: 'var(--color-success)',
        flexShrink: 0,
        ...sx,
      }}
    />
  );
}
